import type { NodesEdgesToSvgPath } from "./types";

export const nodesEdgesToSvgPath: NodesEdgesToSvgPath = ({ nodes, edges }) => {
  if (nodes.length === 0 || edges.length === 0) return "";

  const nodeById = new Map(nodes.map((node) => [node.id, node]));

  const segments: string[] = [];
  for (const edge of edges) {
    const fromNode = nodeById.get(edge.from);
    const toNode = nodeById.get(edge.to);
    if (!fromNode || !toNode) continue;
    segments.push(
      `M ${fromNode.x} ${fromNode.y} L ${toNode.x} ${toNode.y}`,
    );
  }

  return segments.join(" ");
};
